export enum VipCoin {
  BITCOIN = 'BITCOIN',
  USDT_TRC20 = 'USDT_TRC20',
  USDT_ERC20 = 'USDT_ERC20',
}

export enum VipDepositStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  PENDING_REVIEW = 'pending_review',
  CONFIRMED = 'confirmed',
  COMPLETED = 'completed',
  REJECTED = 'rejected',
}

export interface VipRateValue {
  ngn: number;
}

export interface VipRates {
  [VipCoin.BITCOIN]: VipRateValue;
  [VipCoin.USDT_TRC20]: VipRateValue;
  [VipCoin.USDT_ERC20]: VipRateValue;
}

export interface VipSettings {
  minimumDepositUsd: number;
  telegramSupportLink: string;
  enabled: boolean;
  network: 'mainnet' | 'testnet';
  supportedCoins: VipCoin[];
}

export interface VipEligibility {
  eligible: boolean;
  reason?: string;
}

export interface VipAddressResponse {
  address: string;
  coin: VipCoin;
  isNew: boolean;
}

export interface VipDeposit {
  _id: string;
  user: string;
  coin: VipCoin;
  amount: number;
  amountInUsd?: number;
  amountInNGN?: number;
  rateUsed?: number;
  status: VipDepositStatus;
  txId?: string;
  depositAddress?: string;
  confirmations?: number;
  flagged?: boolean;
  flagReason?: string;
  numericalId?: number;
  createdAt: string;
  updatedAt: string;
}

export interface VipDepositsResponse {
  data: VipDeposit[];
  total: number;
  page: number;
  limit: number;
}
